module.exports = __webpack_public_path__ + "static/media/columns.2dbd19a5.png";